module.exports = __webpack_public_path__ + "static/media/voices41.fcb22301.mp3";